var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "component",
    _vm._b(
      {
        staticClass: "wl-control",
        staticStyle: {
          display: "inline-flex",
          "flex-wrap": "wrap",
          width: "100%",
        },
      },
      "component",
      _vm.getMainOptions,
      false
    ),
    [
      _c(
        "component",
        _vm._b(
          {
            ref: "wl-control",
            staticStyle: { width: "100%" },
            attrs: {
              readonly: _vm.$$isReadonly(_vm.options),
              disabled:
                _vm.$$isReadonly(_vm.options) || _vm.$$isDisabled(_vm.options),
            },
            model: {
              value: _vm.controlValue,
              callback: function ($$v) {
                _vm.controlValue = $$v
              },
              expression: "controlValue",
            },
          },
          "component",
          _vm.getOptions,
          false
        ),
        [
          _vm.options.is === "el-select"
            ? _vm._l(_vm.options.options, function (i, v) {
                return _c(
                  "el-option",
                  _vm._b(
                    { key: v, attrs: { disabled: _vm.$$isDisabled(i) } },
                    "el-option",
                    i,
                    false
                  )
                )
              })
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }